<script setup lang="ts">
import type { StrapiBlockInlineListItem } from '@nimbus/types'

const props = defineProps<StrapiBlockInlineListItem>()
</script>

<template>
    <li class="list-item">
        <NimbusStrapiBlockRenderer :content="props.children" />
    </li>
</template>
